<template>
  <v-card-text>
    <v-layout column>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            label="Store Name"
            v-model="Store.businessName"
            :error-messages="businessNameErrors"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm4="sm4">
          <v-text-field
            label="Phone Number"
            v-model="Store.phoneNumber"
            :error-messages="businessPhoneNumberErrors"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm8="sm8">
          <Address @addressSubmit="setAddress"> </Address>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm3="sm3">
          <v-text-field label="City" v-model="Store.city" :error-messages="businessCityErrors">
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm3="sm3">
          <v-autocomplete
            v-model="Store.stateID"
            :items="states"
            :error-messages="businessStateErrors"
            autocomplete="off"
            :filter="customFilter"
            item-text="stateName"
            item-value="stateID"
            label="State"
          >
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm3="sm3">
          <v-text-field
            label="Zipcode"
            v-model="Store.zipcode"
            :error-messages="businessZipcodeErrors"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm3="sm3">
          <v-text-field
            label="Country"
            v-model="Store.country"
            :error-messages="businessCountryErrors"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm6="sm6">
          <v-text-field
            label="Business Email"
            v-model="Store.businessEmail"
            :error-messages="businessEmailErrors"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6="sm6">
          <v-text-field
            label="Invoice Email"
            v-model="Store.invoiceEmail"
            :error-messages="businessInvoiceEmailErrors"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout class="mt-3" row>
        <v-btn color="info" text @click="cancel">{{ $t("buttons.cancel") }}</v-btn>
        <v-spacer> </v-spacer>
        <v-btn color="info" @click="nextStep">{{ $t("buttons.next") }}</v-btn>
      </v-layout>
    </v-layout>
  </v-card-text>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Address from "../../../Global/components/Address";
const { validationMixin } = require("vuelidate");
const { required, minLength, email } = require("vuelidate/lib/validators");
export default {
  computed: {
    ...mapState("location", ["Store"]),
    ...mapGetters("global", ["states"]),
    businessNameErrors() {
      const errors = [];
      if (!this.$v.Store.businessName.$dirty) return errors;
      if (!this.$v.Store.businessName.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Store.businessName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    businessPhoneNumberErrors() {
      const errors = [];
      if (!this.$v.Store.phoneNumber.$dirty) return errors;
      if (!this.$v.Store.phoneNumber.required)
        errors.push(this.$t("validations.phoneNumberIsRequired"));
      return errors;
    },
    businessAddressErrors() {
      const errors = [];
      if (!this.$v.Store.address.$dirty) return errors;
      if (!this.$v.Store.address.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Store.address.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));

      return errors;
    },
    businessCityErrors() {
      const errors = [];
      if (!this.$v.Store.city.$dirty) return errors;
      if (!this.$v.Store.city.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Store.city.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    businessStateErrors() {
      const errors = [];
      if (!this.$v.Store.stateID.$dirty) return errors;
      if (!this.$v.Store.stateID.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    businessZipcodeErrors() {
      const errors = [];
      if (!this.$v.Store.zipcode.$dirty) return errors;
      if (!this.$v.Store.zipcode.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    businessCountryErrors() {
      const errors = [];
      if (!this.$v.Store.country.$dirty) return errors;
      if (!this.$v.Store.country.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Store.country.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    businessEmailErrors() {
      const errors = [];
      if (!this.$v.Store.businessEmail.$dirty) return errors;
      if (!this.$v.Store.businessEmail.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Store.businessEmail.email) errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    businessInvoiceEmailErrors() {
      const errors = [];
      if (!this.$v.Store.invoiceEmail.$dirty) return errors;
      if (!this.$v.Store.invoiceEmail.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Store.invoiceEmail.email) errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    }
  },
  components: {
    Address
  },
  methods: {
    setAddress(val) {
      this.Store.zipcode = val.zipCode;
      this.Store.city = val.city;
      this.Store.country = val.country;
      this.Store.address = val.address;
      this.Store.latitude = val.latitude;
      this.Store.longitude = val.longitude;
      this.Store.stateID = val.stateID;
    },
    cancel() {
      this.$router.push({ name: "location-dashboard" });
    },
    nextStep() {
      this.$v.Store.$touch();
      if (!this.$v.Store.$invalid) {
        this.$emit("nextStep");
      }
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.stateName.toLowerCase();
      const textTwo = item.stateSymbol.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    }
  },
  mixins: [validationMixin],
  validations: {
    Store: {
      businessName: {
        required,
        minLength: minLength(4)
      },
      phoneNumber: {
        required
      },
      address: {
        required,
        minLength: minLength(10)
      },
      city: {
        required,
        minLength: minLength(2)
      },
      stateID: {
        required
      },
      zipcode: {
        required
      },
      country: {
        required,
        minLength: minLength(4)
      },
      businessEmail: {
        required,
        email
      },
      invoiceEmail: {
        required,
        email
      }
    }
  }
};
</script>

<style scoped></style>
